import { useTranslation } from "react-i18next";
export default function Faq() {
    const { t } = useTranslation();
    const points = t("faq.points", { returnObjects: true });
    return (
        <section className="service padding-y-120 position-relative z-index-1">
            {/* <img
        src="/assets/images/gradients/featured-gradient.png"
        alt=""
        className="bg--gradient white-version"
      /> */}
            <div className="container container-two">
                <div className="section-heading justify-content-center style-left style-flex flx-between align-items-end gap-3">
                    <div className="section-heading__inner w-lg">
                        <h3 className="section-heading__title text-center">
                            {t("faq.title")}
                        </h3>
                    </div>
                </div>
                <div className="row gy-4 justify-content-center">
                    {points.map((point, index) => (
                        <div className="col-lg-12" key={index}>
                            <div className="service-item d-flex gap-3 hover-bg-main">
                               
                                <span className="service-item__icon custom__icon">
                                  <img src="/assets/images/icons/question-icon.svg" alt="" />
                                </span>
                                <div>
                                    <h5 className="service-item__title my-3">{point.question}</h5>
                                    <p className="service-item__desc">{point.response}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
